/** @jsxImportSource @emotion/react */

import { css } from "@emotion/react";

import { useTranslation } from "react-i18next";

import { TOGGLE_SWITCH_SIZES, ToggleSwitch } from "@/components/ToggleSwitch";
import { API_CREDENTIAL_STATUS, TableRowData } from "@/shared";

import { useTableStyles } from "../../styles/styles";

interface InlineToggleSwitchProps {
  row: TableRowData;
  rowSwitch: any;
}

const InlineToggleSwitch = ({ row, rowSwitch }: InlineToggleSwitchProps) => {
  const { t } = useTranslation();

  const { firstTableInlineAction } = useTableStyles(rowSwitch);

  const { enabled, status } = row;

  const isExpired = status === API_CREDENTIAL_STATUS.Expired;

  return (
    <>
      <div css={css(firstTableInlineAction)} />
      <ToggleSwitch
        preventParentOnClick
        size={TOGGLE_SWITCH_SIZES.Medium}
        checked={Boolean(enabled) && !isExpired}
        disabled={status === API_CREDENTIAL_STATUS.Expired}
        onChange={() => rowSwitch.toggleAction(row)}
        justifyContent="center"
        customCSS={{ marginLeft: "24px", width: "100%" }}
        tooltipText={
          isExpired ? t("Table##expired integration tooltip") : undefined
        }
      />
    </>
  );
};

export default InlineToggleSwitch;
